'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addressValueFor = addressValueFor;
exports.getDeliveryMethodStyleName = getDeliveryMethodStyleName;

var _lodash = require('lodash');

function addressValueFor(type, name, addressDetails, order) {
  if (addressDetails[name] !== undefined && addressDetails[name] !== '') {
    return addressDetails[name];
  }

  var addressAttributes = order[type + 'Address'];

  if (addressAttributes && (0, _lodash.has)(addressAttributes, name)) {
    return addressAttributes[name];
  }

  return null;
}

function getDeliveryMethodStyleName(deliveryAvailable) {
  if (deliveryAvailable === true) {
    return 'm-delivery-method';
  }

  return 'm-delivery-method-unavailable';
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/address.js
// module id = 360
// module chunks = 0